"use strict";

function chooseDateTime$(e) {
  return ddSdk_1.ddSdk.invokeAPI(apiName, e);
}

var _a;

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.chooseDateTime$ = void 0;

var ddSdk_1 = require("../../../lib/ddSdk"),
    apiHelper_1 = require("../../../lib/apiHelper"),
    apiName = "biz.calendar.chooseDateTime";

ddSdk_1.ddSdk.setAPI(apiName, (_a = {}, _a[ddSdk_1.ENV_ENUM.ios] = {
  vs: "3.5.0",
  paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal
}, _a[ddSdk_1.ENV_ENUM.android] = {
  vs: "3.5.0",
  paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal
}, _a)), exports.chooseDateTime$ = chooseDateTime$, exports.default = chooseDateTime$;